import { __makeTemplateObject } from "tslib";
import styled from '@emotion/styled';
import { Paper, Table, TableHead, TableRow } from '@material-ui/core';
import * as React from 'react';
export var StyledForm = styled.form(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  max-width: 32rem;\n"], ["\n  display: flex;\n  flex-direction: column;\n  max-width: 32rem;\n"])));
export var FieldWrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin: ", "px 0;\n"], ["\n  margin: ", "px 0;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacing(0.75);
});
export var Actions = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  justify-content: ", ";\n  margin-top: ", "px;\n"], ["\n  display: flex;\n  justify-content: ",
    ";\n  margin-top: ", "px;\n"])), function (_a) {
    var children = _a.children;
    return React.Children.toArray(children).filter(function (x) { return !!x; }).length > 1
        ? 'space-between'
        : 'flex-end';
}, function (_a) {
    var theme = _a.theme;
    return theme.spacing(2);
});
export var EmptyContainer = styled(Paper)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  margin-top: ", "px;\n  margin-bottom: ", "px;\n  padding: ", "px;\n  height: 400px;\n"], ["\n  margin-top: ", "px;\n  margin-bottom: ", "px;\n  padding: ", "px;\n  height: 400px;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacing(1);
}, function (_a) {
    var theme = _a.theme;
    return theme.spacing(1);
}, function (_a) {
    var theme = _a.theme;
    return theme.spacing(2);
});
export var LoaderWrapper = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  flex: 1;\n  text-align: center;\n  align-items: center;\n"], ["\n  flex: 1;\n  text-align: center;\n  align-items: center;\n"])));
export var StyledTableContainer = styled(Paper)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  margin-top: ", "px;\n  margin-bottom: ", "px;\n  padding: ", "px;\n"], ["\n  margin-top: ", "px;\n  margin-bottom: ", "px;\n  padding: ", "px;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacing(1);
}, function (_a) {
    var theme = _a.theme;
    return theme.spacing(1);
}, function (_a) {
    var theme = _a.theme;
    return theme.spacing(2);
});
export var StyledTable = styled(Table)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  table-layout: fixed;\n"], ["\n  table-layout: fixed;\n"])));
export var StyledTableHead = styled(TableHead)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  th {\n    font-size: 16px;\n    font-weight: ", ";\n    color: #757575;\n    vertical-align: top;\n  }\n"], ["\n  th {\n    font-size: 16px;\n    font-weight: ", ";\n    color: #757575;\n    vertical-align: top;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.typography.fontWeightMedium;
});
export var StyledTableRow = styled(TableRow)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  &:hover {\n    background-color: #f0f0f7;\n    cursor: pointer;\n  }\n\n  td {\n    vertical-align: top;\n  }\n"], ["\n  &:hover {\n    background-color: #f0f0f7;\n    cursor: pointer;\n  }\n\n  td {\n    vertical-align: top;\n  }\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;
